export default __webpack_public_path__ + "static/media/collpase-icon.d47aa396.svg";